import React from "react";

const ArrowLeft = ({
  width = 6,
  height = 10,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.20401 4.99956L5.91651 8.71206L4.85601 9.77256L0.0830078 4.99956L4.85601 0.226562L5.91651 1.28706L2.20401 4.99956Z"
        fill="#525866"
      />
    </svg>
  );
};

export default ArrowLeft;
